import React from "react";
import { useTranslation } from "react-i18next";

const CommonSectionArea = ({ area_header }) => {
  const { t } = useTranslation();
  return (
    <>
      <section className="about-area pt-120 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-5">{area_header}</div>
            <div className="col-xl-6 col-lg-7">
              <div className="about-right-side mb-30">
                <div className="about-title mb-20">
                  <h5>{t("header.about")}</h5>
                  <h1>{t("aboutus.aboutCompany")}</h1>
                </div>
                <div className="about-text mb-50">
                  <p>{t("footer.about")}</p>
                </div>
                <div className="our-destination">
                  <div className="single-item mb-30">
                    <div className="mv-icon f-left">
                      <img src="img/about/destination-icon-1.png" alt="" />
                    </div>
                    <div className="mv-title fix">
                      <h3>{t("aboutus.area.ourmission")}</h3>
                      <p>{t("aboutus.area.ourmissionContent")}</p>
                    </div>
                  </div>
                  <div className="single-item">
                    <div className="mv-icon f-left">
                      <img src="img/about/destination-icon-2.png" alt="" />
                    </div>
                    <div className="mv-title fix">
                      <h3>{t("aboutus.area.vision")}</h3>
                      <p>{t("aboutus.area.visionContent")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CommonSectionArea;
